import React from 'react';
import { Flex, Box, Heading } from '@chakra-ui/react';
import history from 'history/browser';
import { GhostButton } from 'components/lib';

export const NotFound = () => {
    return (
        <Flex
            height="100vh"
            width="100vw"
            justify="center"
            align="center"
            flexDir="column">
            <Box padding="4" borderLeft="4px solid black" marginBottom="4">
                <Heading size="lg" color="ecp.900">
                    404
                </Heading>
                <Heading size="sm" color="ecp.900">
                    The page could not be found
                </Heading>
            </Box>
            <GhostButton onClick={history.back}>Go back</GhostButton>
        </Flex>
    );
};
